<template>
  <div class="uk-card-body">
    <!--header-->
    <div class="uk-text-bold" style="background-color: #4caf50; color: #fff;">
      <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid" data-uk-grid>
        <div class="uk-width-auto">
          <div style="width: 60px;" class="uk-padding-small">

          </div>
        </div>
        <div class="uk-width-expand">
          <div class="uk-padding-small">
            Функция
            <a href="#" class="uk-display-inline-block uk-link-reset" data-uk-tooltip="title: Сортировка по названию фукнции">
              <span class="uk-icon" @click="setSortingData('name','asc')">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon>
                  <line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line>
                </svg>
              </span>
              <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('name','desc')">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon>
                  <line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line>
                </svg>
              </span>
            </a>
          </div>
        </div>
        <div class="uk-width-small">
          <div class="uk-padding-small">Категория</div>
        </div>
        <div class="uk-width-small">
          <div class="uk-padding-small">Элементы</div>
        </div>
        <div class="uk-width-small">
          <div class="uk-padding-small">Примеры</div>
        </div>
        <div class="uk-width-small">
          <div class="uk-padding-small">Кредит</div>
        </div>
        <div class="uk-width-small">
          <div class="uk-padding-small">Цена</div>
        </div>
        <div class="uk-width-small">
          <div class="uk-padding-small">Видео</div>
        </div>
        <div class="uk-width-auto">
          <div style="width: 60px;" class="uk-padding-small"></div>
        </div>
      </div>
    </div>
    <div class="uk-padding-small" v-if="items.length === 0">
      Поиск не дал результатов
    </div>
    <div v-else>
      <!--list-->
      <template v-for="(functionItem, key) in items[pagination.currentPage - 1]">
        <div class="uk-grid-collapse uk-text-center uk-flex-middle tm-grid-bg-hover uk-grid" :key="key" data-uk-grid>
          <!--Иконка функции-->
          <div class="uk-width-auto">
            <div style="width: 60px;" class="uk-padding-small">
              <img class="tm-func-icon" :src="functionItem.icon" alt="">
            </div>
          </div>
          <!--Название функции-->
          <div class="uk-width-expand uk-text-left">
            <div class="uk-padding-small">
              {{ functionItem.name }}
              <div class="uk-text-small uk-text-muted">
                {{ local_page_keys[functionItem.name] }}
              </div>
            </div>
          </div>
          <!--Категория функции-->
          <div class="uk-width-small">
            <div class="uk-padding-small">
              {{ functionItem.category }}
            </div>
          </div>
          <!--Элементы-->
          <div class="uk-width-small">
            <div class="uk-padding-small">
              {{ functionItem.elements ? functionItem.elements.length : 0 }}
            </div>
          </div>
          <!--Примеры-->
          <div class="uk-width-small">
            <div class="uk-padding-small">
              {{ functionItem.examples ? functionItem.examples.length : 0 }}

            </div>
          </div>
          <!--Кредиты-->
          <div class="uk-width-small">
            <div class="uk-padding-small">
              {{ (functionItem.credits) ? (Math.round(functionItem.credits * 100) / 100).toFixed(2) : 0 }}
            </div>
          </div>
          <!--Цена-->
          <div class="uk-width-small">
            <div class="uk-padding-small">
              {{ (Math.round(functionItem.price * 100) / 100).toFixed(2) }}
            </div>
          </div>
          <!--Видео-->
          <div class="uk-width-small">
            <div class="uk-padding-small" v-html="getVideoLinks(functionItem)"></div>
          </div>
          <div class="uk-width-auto">
            <div class="uk-padding-small uk-flex uk-text-center uk-flex-center" style="min-width: 50px;">
              <button type="button" @click="$emit('openEdit',functionItem.id)"
                      data-uk-icon="file-edit" style="padding: 0 5px;"
                      class="uk-icon uk-link-text" data-uk-tooltip="title: Редактировать фукнцию">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-svg="file-edit">
                  <path fill="none" stroke="#000" d="M18.65,1.68 C18.41,1.45 18.109,1.33 17.81,1.33 C17.499,1.33 17.209,1.45 16.98,1.68 L8.92,9.76 L8,12.33 L10.55,11.41 L18.651,3.34 C19.12,2.87 19.12,2.15 18.65,1.68 L18.65,1.68 L18.65,1.68 Z"></path>
                  <polyline fill="none" stroke="#000" points="16.5 8.482 16.5 18.5 3.5 18.5 3.5 1.5 14.211 1.5"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <hr class="uk-margin-remove" :key="key+'_0'">
      </template>
      <!--Пагинация-->
      <ul class="uk-pagination tm-pagination uk-flex-center uk-margin">
        <li :class="(pagination.currentPage <= 1 ? 'uk-disable' : '')">
          <a href="#" class="uk-link-reset" @click="goToPrevious">
            <span data-uk-pagination-previous></span>
          </a>
        </li>
        <template v-for="page in pagination.totalPages">
          <li :key="page" class="uk-active" v-if="pagination.currentPage == page">
            <span>
              {{ pagination.currentPage }}
            </span>
          </li>
          <li :key="page" @click="goToPage(page)" v-else>
            <a href="#" class="uk-link-reset">{{ page }}</a>
          </li>
        </template>
        <li :class="(pagination.currentPage >= pagination.totalPages ? 'uk-disable' : '')">
          <a href="#" class="uk-link-reset" @click="goToNext">
            <span data-uk-pagination-next></span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 500],
        totalPages: null,
      },
      sort: {
        field: 'name',
        type: 'asc',
      },
      functionsList: [],
      path: process.env.VUE_APP_API_URL,
      items: [],
    };
  },
  props: {functions: {type: [Array, Object]}, searchString: String, local_page_keys:{type: Object}},
  methods: {
    paginate() {
      this.pagination.totalPages = Math.ceil(this.functionsList.length / this.pagination.perPage);
      let chunked = [];
      for (let i = 0; i < this.pagination.totalPages; i++) {
        chunked[i] = this.functionsList.slice(i * this.pagination.perPage, ((i + 1) * this.pagination.perPage));
      }
      this.items = chunked;
    },
    goToNext() {
      if (this.pagination.currentPage + 1 > this.pagination.totalPages) {
        return;
      }
      this.pagination.currentPage++;
    },
    goToPrevious() {
      if (this.pagination.currentPage - 1 <= 0) {
        return;
      }
      this.pagination.currentPage--;
    },
    goToPage(page) {
      this.pagination.currentPage = page;
    },
    sorting(field, type) {
      if (type == 'asc') {
        this.functionsList = this.functionsList.sort((a, b) => (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0));
      } else {
        this.functionsList = this.functionsList.sort((a, b) => (b[field] > a[field]) ? 1 : ((a[field] > b[field]) ? -1 : 0));
      }
    },
    setSortingData(field, type) {
      this.sort.type = type == 'asc' ? 'asc' : 'desc';
      this.sort.field = field;
      this.rebuild();
    },
    search() {
      const searchStringLower = this.searchString.toLowerCase();
      this.functionsList = this.functionsList.filter(o => o.translated.toLowerCase().includes(searchStringLower) || o.name.toLowerCase().includes(searchStringLower)); // Преобразование и сравнение в нижнем регистре
    },
    async rebuild() {
      this.functionsList = this.functions;
      await this.search();
      await this.sorting(this.sort.field, this.sort.type);
      await this.paginate();
    },
    checkURLParams() {
      const currentURL = window.location.href;
      const parameterIndex = currentURL.indexOf('#');
      if (parameterIndex !== -1) {
        const nameFunction = currentURL.slice(parameterIndex + 1);
        const foundItemfunction = this.functions.find(item => item.name === nameFunction);
        if(foundItemfunction) {
          this.$emit('openEdit',foundItemfunction.id)
        }
      }
    },
    getVideoLinks(items) {
      const videoLessons = items.examples.filter(item => item.type === "video" && item.video_lesson);
      const videoLinks = videoLessons.map(item => ({
        id: item.id,
        url: item.video_lesson,
      }));
      return  videoLinks.map(item => `<a href="${item.url}" target="_blank"><i class="md-icon md-icon-font md-theme-default">smart_display</i></a>`).join("\n");
    }

  },
  created() {
    this.checkURLParams();
    this.rebuild();
  },
  watch: {
    searchString: function (newVal, oldVal) {
      this.rebuild();
    },
    functions: function (newVal, oldVal) {
      this.rebuild();
    }
  }
}
</script>